import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VideoChatCallToastComponent } from 'shared/components/video-chat-call-toast/video-chat-call-toast.component';
import { AvatarModule } from 'shared/components/avatar/avatar.module';
import { SvgIconModule } from 'shared/components/svg-icon/svg-icon.module';
import { TranslateModule } from '@ngx-translate/core';
import { DragDropModule } from '@angular/cdk/drag-drop';

@NgModule({
  imports: [
    CommonModule,
    AvatarModule,
    SvgIconModule,
    DragDropModule,
    TranslateModule.forChild()
  ],
  declarations: [
    VideoChatCallToastComponent
  ],
  exports: [
    VideoChatCallToastComponent
  ]
})
export class VideoChatCallToastModule {}
